export const CHATBOT_PAYLOAD = {
  Initial: 'initial',
  Closing: 'closing',
  SendMessage: 'sendMessage',
} as const;
